module.exports = __webpack_public_path__ + "img/dry-dirt.e8d4cfdf.png";